module.exports = __webpack_public_path__ + "img/flower1.6caee42e.jpg";